<template>
  <div v-if="!isMinimalHeader">
    <header>
      <nav class="site-header" :class="{ 'site-header__legacy': !isPwa }">
<!--        <AppBanner v-if="!isDesktop && !searchIsOpen" class="android-only-flex" :dictionary="dictionary" />-->
        <XmasBanner v-if="!searchIsOpen && isXmasSeason" :dictionary="dictionary" :show-express-and-box="showExpressAndBox" />
        <div v-if="headlineBarData" :class="{'d-none d-md-block': searchIsOpen}">
          <a v-if="headlineBarData.redirectUrl && headlineBarData.redirectUrl.length > 0 && headlineBarData.content.indexOf('<a') < 0"
             class="headline-bar"
                     :style="`background-color: #${headlineBarData.bgColor};`"
                     :href="headlineBarData.redirectUrl"
                     v-html="headlineBarData.content"
                     role="link">
          </a>
          <div v-else
               class="headline-bar"
               :style="`background-color: #${headlineBarData.bgColor};`"
               v-html="headlineBarData.content"
          >
          </div>
        </div>

        <div class="site-header__content">
            <div class="site-header__container">
              <!-- Link -->
              <NuxtLink v-if="isPwa" to="/" :title="dictionary.siteHeader.logoTitle" role="link" class="site-header__logo-container">
                <LogoRO v-if="langDefault === 'ro'" />
                <LogoAT v-else-if="langDefault === 'at'" />
                <LogoHU v-else-if="langDefault === 'hu'" />
                <LogoSK v-else-if="langDefault === 'sk'" />
                <LogoCZ v-else />
              </NuxtLink>
              <a v-else href="/" :title="dictionary.siteHeader.logoTitle" role="link" class="site-header__logo-container">
                <LogoRO v-if="langDefault === 'ro'" />
                <LogoAT v-else-if="langDefault === 'at'" />
                <LogoHU v-else-if="langDefault === 'hu'" />
                <LogoSK v-else-if="langDefault === 'sk'" />
                <LogoCZ v-else />
              </a>
              <!-- end Link -->

              <TheSearch
                  @mobileMenu="openMenuCategory = !openMenuCategory"
                  :langDefault="langDefault"
                  :base-url="basicUrl"
                  :is-pwa="isPwa"
                  :last-visited-product-ids="lastVisitedProductIds"
                  @addProductToBasket="addProductToBasket"
                  :product-amounts="productAmounts"
                  :dictionary="dictionary"
                  :search-is-open="searchIsOpen"
                  @opened="searchIsOpen = true"
                  @closed="searchIsOpen = false"
                  @autocompleteResults="autocompleteResults"
                  @autocompleteClickResult="autocompleteClickResult"
              />

              <div v-if="isDesktop" class="site-header__right site-header__right--desktop justify-content-end">
                <a v-if="langDefault === 'cz' && dictionary.siteHeader.pharmacies"
                   :href="dictionary.url.pharmacies"
                   class="link lg-only"
                   :title="dictionary.siteHeader.pharmacies"
                   tabindex="-1"
                >
                  <img src="/nuxt-assets/images/icons/pharmacy2.svg" :alt="dictionary.siteHeader.pharmacies" />
                  <span class="site-ico__label fs-14">{{ dictionary.siteHeader.pharmacies }}</span>
                </a>

                  <a v-if="dictionary.siteHeader.counselling"
                      :href="dictionary.url.counselling"
                      class="link lg-only"
                      :title="dictionary.siteHeader.counselling"
                      tabindex="-1"
                  >
                      <img src="/nuxt-assets/images/icons/counselling.svg" :alt="dictionary.siteHeader.counselling" />
                      <span class="site-ico__label fs-14">{{ dictionary.siteHeader.counselling }}</span>
                  </a>

<!--                  <a v-if="isUserAuthenticated"-->
<!--                      :href="isUserAuthenticated ? dictionary.url.user.myFavorite : dictionary.url.user.login"-->
<!--                      class="link"-->
<!--                      :title="dictionary.siteHeader.favorite"-->
<!--                      tabindex="-1"-->
<!--                  >-->
<!--                      <i class="ico ico&#45;&#45;heart-pink" :title="dictionary.siteHeader.favorite"></i>-->
<!--                      <span v-if="favoriteCount > 0" class="site-header__right__link__count font-weight-bold">-->
<!--                    {{ favoriteCount }}-->
<!--                  </span>-->

<!--                      <span class="site-ico__label fs-14">{{ dictionary.siteHeader.favorite }}</span>-->
<!--                  </a>-->
                <div class="user site-header__corner" @mouseenter="openUserPopup" @mouseleave="closeUserPopup" :class="{'site-header__corner__active active': isUserBoxOpen}">
                  <UserPopupLogged v-if="isUserAuthenticated" :show-popup="isUserBoxOpen" :username="username" :dictionary="dictionary" />
                  <UserPopupNotLogged :is-pwa="isPwa" :show-popup="isUserBoxOpen" :dictionary="dictionary" :uid="basket.uid" :base-url="basicUrl" v-else @logged="logged" />

                  <a :href="dictionary.url.user.orders"
                     v-if="isUserAuthenticated"
                     class="link"
                     :title="dictionary.siteHeader.login.orders"
                     tabindex="-1"
                  >
                    <img src="/nuxt-assets/images/icons/user.svg" :alt="dictionary.siteHeader.login.orders" />
                    <span class="site-ico__label fs-14">{{ username }}</span>
                  </a>
                  <a :href="dictionary.url.user.login"
                     v-if="!isUserAuthenticated"
                     class="link"
                     :title="dictionary.siteHeader.login.title"
                     tabindex="-1"
                  >
                    <img src="/nuxt-assets/images/icons/user.svg" :alt="dictionary.siteHeader.login.title" />
                    <span class="site-ico__label fs-14">
                    {{ dictionary.siteHeader.login.title }}
                  </span>
                  </a>
                </div>

                  <button v-if="fastestPossibleDeliveryDate"
                      :href="isUserAuthenticated ? dictionary.url.user.myFavorite : dictionary.url.user.login"
                      class="link"
                      :title="fastestPossibleDeliveryDate"
                      tabindex="-1"
                      @click="$emit('fastestPossibleDeliveryDateClicked')"
                  >
                      <img src="/nuxt-assets/images/icons/badge-delivery-black.svg" :alt="fastestPossibleDeliveryDate" />
                      <span class="site-ico__label fs-14">{{ fastestPossibleDeliveryDate }}</span>
                  </button>
                <div id="js-cart-box" class="cart d-block">
                  <div class="cart-box">
                    <CartBox
                        v-if="isPwa"
                        :is-pwa="isPwa"
                        @addProductToBasket="addProductToBasket"
                        :basket="basket"
                        :cart-box-banner="cartBoxBanner"
                        :product-amounts="productAmounts"
                        :progress-bars="progressBars"
                        :dictionary="dictionary"
                    />
                  </div>
                  <NuxtLink
                      v-if="isPwa"
                      class="link"
                      :title="dictionary.siteHeader.menu.transport"
                      tabindex="-1"
                      :to="dictionary.url.cartStep1"
                  >
                    <img src="/nuxt-assets/images/icons/basket.svg" :alt="dictionary.siteHeader.basket" />

                    <strong id="js-cart-amount-desktop" v-if="basket.totalAmount" class="site-header__right__link__count font-weight-bold">
                      {{ basket.totalAmount }}
                    </strong>

                    <span class="site-header__right__link__text">
                      <span
                          id="js-cart-price-desktop"
                          class="notranslate"
                          v-if="basket.price.totalPrice"
                          v-html="$formatCurrency(basket.price.afterDiscountPrice)"
                      ></span>
                      <template v-else>{{ dictionary.siteHeader.basket }}</template>
                    </span>
                  </NuxtLink>
                  <a
                      v-else
                      class="link"
                      :title="dictionary.siteHeader.menu.transport"
                      tabindex="-1"
                      :href="dictionary.url.cartStep1"
                  >
                    <img src="/nuxt-assets/images/icons/basket.svg" :alt="dictionary.siteHeader.basket" />

                    <strong id="js-cart-amount-desktop" v-if="basket.totalAmount" class="site-header__right__link__count font-weight-bold">
                      {{ basket.totalAmount }}
                    </strong>

                    <span class="site-header__right__link__text">
                      <span
                          id="js-cart-price-desktop"
                          class="notranslate"
                          v-if="basket.price.totalPrice"
                          v-html="$formatCurrency(basket.price.afterDiscountPrice)"
                      ></span>
                      <template v-else>{{ dictionary.siteHeader.basket }}</template>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <DesktopMainMenu
                v-if="isDesktop"
                :items="items"
                :menu-banners="menuBanners"
                :menu-brand-banners="menuBrandBanners"
                :sale-banners="saleBanners"
                :pinned-categories="pinnedCategories"
                :menu-item-products="menuItemProducts"
                :xmas-category-id="xmasCategoryId"
                :menu-highlight-category="menuHighlightCategory"
                :product-amounts="productAmounts"
                :dictionary="dictionary"
                :is-pwa="isPwa"
                @update:openMenu="openMenu = $event"
                @menuMouseOver="$emit('menuMouseOver')"
                @addProductToBasket="addProductToBasket"
                @redirectToUrl="redirectToUrl"
            >
                <template v-slot:product="{ product }">
                    <slot name="product" v-bind="{ product }"></slot>
                </template>
            </DesktopMainMenu>
          </div>
      </nav>
      <MobileMenuCategory
          v-if="!isDesktop"
          :items="items"
          :menu-banners="menuBanners"
          :menu-brand-banners="menuBrandBanners"
          :pinned-categories="pinnedCategories"
          :is-desktop="isDesktop"
          :open="menuOpen"
          :menu-item-products="menuItemProducts"
          :is-pwa="isPwa"
          :langDefault="langDefault"
          :xmas-category-id="xmasCategoryId"
          :menu-highlight-category="menuHighlightCategory"
          :product-amounts="productAmounts"
          :dictionary="dictionary"
          :saleBanners="saleBanners"
          @toggleMenu="openMenuCategory"
          @addProductToBasket="addProductToBasket"
          @redirectToUrl="redirectToUrl"
      >
          <template v-slot:product="{ product }">
              <slot name="product" v-bind="{ product }"></slot>
          </template>
      </MobileMenuCategory>
    </header>
    <MainMenu
        :is-pwa="isPwa"
        :user-box-title="dictionary.siteHeader.login.label"
        :user-box-link="dictionary.siteHeader.login.label"
        :total-amount="basket.totalAmount"
        :total-price="basket.price.afterDiscountPrice"
        :user-authentication="isUserAuthenticated"
        :username="username"
        :langDefault="langDefault"
        :xmas-category-id="xmasCategoryId"
        :menu-highlight-category="menuHighlightCategory"
        :product-amounts="productAmounts"
        :dictionary="dictionary"
        :uid="basket.uid"
        :base-url="basicUrl"
        @toggleMenu="openMenuCategory"
        @addProductToBasket="addProductToBasket"
        @redirectToUrl="redirectToUrl"
        @logged="logged"
    />
  </div>
  <div v-else>
    <header class="minimal-header">
      <nav class="site-header" :class="{ 'site-header__legacy': !isPwa }">
        <div v-if="headlineBarData">
          <a v-if="headlineBarData.redirectUrl && headlineBarData.redirectUrl.length > 0 && headlineBarData.content.indexOf('<a') < 0"
             class="headline-bar"
             :style="`background-color: #${headlineBarData.bgColor};`"
             :href="headlineBarData.redirectUrl"
             v-html="headlineBarData.content"
             role="link">
          </a>
          <div v-else
               class="headline-bar"
               :style="`background-color: #${headlineBarData.bgColor};`"
               v-html="headlineBarData.content"
          >
          </div>
        </div>

        <div class="site-header__content container">
          <div class="site-header__container container" style="flex-direction: row;">
            <!-- Link -->
            <NuxtLink v-if="isPwa" to="/" :title="dictionary.siteHeader.logoTitle" role="link" class="site-header__logo-container site-minimal-header__logo-container">
              <LogoRO v-if="langDefault === 'ro'" />
              <LogoAT v-else-if="langDefault === 'at'" />
              <LogoHU v-else-if="langDefault === 'hu'" />
              <LogoSK v-else-if="langDefault === 'sk'" />
              <LogoCZ v-else />
            </NuxtLink>
            <a
                v-else href="/"
                :title="dictionary.siteHeader.logoTitle"
                role="link"
                class="site-header__logo-container site-minimal-header__logo-container">
              <LogoRO v-if="langDefault === 'ro'" />
              <LogoAT v-else-if="langDefault === 'at'" />
              <LogoHU v-else-if="langDefault === 'hu'" />
              <LogoSK v-else-if="langDefault === 'sk'" />
              <LogoCZ v-else />
            </a>
            <!-- end Link -->

            <div v-if="isDesktop" class="site-minimal-header__support-container">
              <div>
                <img v-if="customerCareStatus === 'chat'" :src="`/nuxt-assets/images/icons/chat.svg`" alt="Chat" loading="lazy" />
                <img v-else :src="`/nuxt-assets/images/icons/phone-dark-grey.svg`" :alt="dictionary.phone" loading="lazy" />
              </div>
              <div class="support-container__info">
                <a v-if="customerCareStatus === 'phone'" class="support-container__phone" :href="`tel:${dictionary.phone}`">
                  <b>{{ dictionary.phone }}</b>
                </a>
                <a v-else-if="customerCareStatus === 'chat'" class="support-container__link" :href="dictionary.contact" @click="openChat">
                  {{ dictionary.siteHeader.startChat }}
                </a>
                <a v-else class="support-container__link" :href="dictionary.contact">
                  {{ dictionary.phoneAvailability }}
                </a>
              </div>
            </div>

            <div class="site-header__right justify-content-end">
              <div class="user site-header__corner" @mouseenter="openUserPopup" @mouseleave="closeUserPopup" :class="{'site-header__corner__active active': isUserBoxOpen}">
                <UserPopupLogged v-if="isUserAuthenticated" :show-popup="isUserBoxOpen" :username="username" :dictionary="dictionary" />
                <UserPopupNotLogged :is-pwa="isPwa" :show-popup="isUserBoxOpen" :dictionary="dictionary" :uid="basket.uid" :base-url="basicUrl" v-else @logged="logged" />

                <a v-if="isUserAuthenticated"
                   :href="dictionary.url.user.orders"
                   class="link"
                   :title="dictionary.siteHeader.login.title"
                   tabindex="-1"
                >
                  <img src="/nuxt-assets/images/icons/user.svg" :alt="username" />
                  <span class="site-ico__label fs-14">{{ username }}</span>
                </a>

                <a v-if="!isUserAuthenticated"
                   :href="dictionary.url.user.login"
                   class="link"
                   :title="dictionary.siteHeader.login.title"
                   tabindex="-1"
                >
                  <img src="/nuxt-assets/images/icons/user.svg" :alt="dictionary.siteHeader.login.title" />
                  <span class="site-ico__label fs-14">
                      {{ dictionary.siteHeader.login.title }}
                    </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
import DesktopMainMenu from "./desktop/MainMenu";
import TheSearch from "./elements/TheSearch";
import UserPopupNotLogged from "./elements/UserPopupNotLogged";
import UserPopupLogged from "./elements/UserPopupLogged";
import CartBox from "./elements/CartBox";
import MobileMenuCategory from "./mobile/MenuCategory";
import MainMenu from "./mobile/MainMenu";
import LogoCZ from "./elements/LogoPilulkaCZ";
import LogoSK from "./elements/LogoPilulkaSK";
import LogoRO from "./elements/LogoPilulkaRO";
import LogoAT from "./elements/LogoPilulkaAT";
import LogoHU from "./elements/LogoPilulkaHU";
// import AppBanner from "./elements/AppBanner";
import XmasBanner from "./elements/XmasBanner.vue";

export default {
  name: "TheHeader",

  components: {
    XmasBanner,
    DesktopMainMenu,
    TheSearch,
    UserPopupNotLogged,
    CartBox,
    MainMenu,
    MobileMenuCategory,
    LogoCZ,
    LogoSK,
    LogoRO,
    LogoAT,
    LogoHU,
    UserPopupLogged,
  },

  props: {
    productAmounts: {
      type: Object,
      required: false,
      default: () => {},
    },
    progressBars: {
      type: Array,
      default: () => {
        return []
      },
    },
    lastVisitedProductIds: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
    isPwa: {
      type: Boolean,
      required: true,
    },
    cartBoxBanner: {
      type: Object,
    },
    basket: {
      type: Object,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      default: true,
    },
    items: {
      default: false,
    },
    pinnedCategories: {
      default: false,
    },
    menuBanners: {
      type: Array,
    },
    menuBrandBanners: {
      type: Array,
    },
    saleBanners: {
      type: Array,
      default: null,
    },
    isUserAuthenticated: {
      type: Boolean,
      default: false,
    },
    isUserPremium: {
      type: Boolean,
      default: false,
    },
    username: {
      type: String,
      default: "",
    },
    basicUrl: {
      type: String,
      default: "",
    },
    favoriteCount: {
      type: Number,
      default: 0,
      required: true,
    },
    langDefault: {
      type: String,
      default: "",
    },
    menuItemProducts: {
      default: false
    },
    xmasCategoryId: {
      type: Number,
      required: false,
    },
    menuHighlightCategory: {
      type: Number,
      required: false,
    },
    headlineBarData: {
      type: Object,
      required: false,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    isMinimalHeader: {
      type: Boolean,
      default: false,
      required: false,
    },
    isXmasSeason: {
      type: Boolean,
      default: false,
      required: false,
    },
    fastestPossibleDeliveryDate: {
      type: String,
      default: "",
    },
    customerCareStatus: {
      type: String,
      default: "closed",
    }
  },

  data() {
    return {
      searchIsOpen: false,
      isUserBoxOpen: false,
      openMenu: false,
      menuOpen: false,
      lastScrollTop: 0,
      pageYOffset: 0,
    };
  },

  computed: {
    strippedSupportLink() {
      let regex = /(<([^>]+)>)/ig;
      return this.dictionary.chat.replace(regex, " ");
    },

    showExpressAndBox() {
      return this.langDefault === 'cz' || this.langDefault === 'sk';
    }
  },

  mounted() {
    this.onScroll();

    /* For Desktop */
    window.addEventListener('scroll',() => {
      if( !document.getElementById("mainMenu")?.classList.contains('menu--opened') ) {
        this.onScroll()
      }
    });
    /* For Mobile */
    document.getElementById('__nuxt')?.addEventListener('scroll',() => {
      this.onScroll();
    });
  },

  methods: {
    logged(data) {
      this.$emit('logged', data);
    },

    openChat(e) {
      if (window.chat) {
        e.preventDefault();

        window.loadAndOpenAmioChat();
      } else {
        return true;
      }
    },

    addProductToBasket(data) {
      this.$emit('addProductToBasket', data)
    },

    autocompleteResults(queryString, items) {
        this.$emit('autocompleteResults', queryString, items)
    },

    autocompleteClickResult(clickType, item) {
      this.$emit('autocompleteClickResult', clickType, item)
    },

    openMenuCategory() {
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen) {
        this.$emit('menuIsVisible')
        localStorage.setItem('pageYOffset', window.pageYOffset);
        setTimeout(() => {
          document.body.classList.add("fixed-page");
        }, 0)
      } else {
        setTimeout(() => {
          document.body.classList.remove("fixed-page");
        }, 0)
        window.scrollTo(0,  parseInt(localStorage.getItem('pageYOffset')))
      }
    },
    openUserPopup() {
      this.isUserBoxOpen = true;
    },
    closeUserPopup() {
      if (document.activeElement.tagName !== "INPUT") {
        this.isUserBoxOpen = false;
      }
    },
    onScroll() {
      const st = window.pageYOffset || document.documentElement.scrollTop || document.getElementById('__nuxt')?.scrollTop;
      const heightWindow = window.innerHeight;
      const stickyElement = document.body.classList;

      if (!this.openMenu && this.isPwa) {
        st > this.lastScrollTop
            ? stickyElement.add("header-sticky")
            : stickyElement.remove("header-sticky");

        this.lastScrollTop = st <= 0 ? 0 : st;
      }
    },
    redirectToUrl(data) {
      this.$emit('redirectToUrl', data)
    },
  },
};
</script>
<style lang="scss">
$breakPointForSmallHeader: 768px;

header {
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
}

.minimal-header {
  @media (min-width: 768px) {
    margin-bottom: -50px;
  }
}

.cart-box {
    position: absolute;
    display: none;
    top: 100%;
    margin-top: -1px;
    right: 0;
    background: #fff;
    padding: 10px;
    width: 540px;
    font-size: 14px;
    z-index: 999;

    @media (max-width: 767.98px) {
        position: fixed;
        top: 47px;
        width: 100%;
        left: 0;
        bottom: 0;
        background: #fff;
    }

    @media (min-width: 768px) {
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
    }

    &--open {
        display: block;
        z-index: 20;

        @media (hover: none) {
            display: none;
        }
    }

    &__contents {
        max-height: 50vh;
        overflow-y: auto;
    }

    &__footer {
        background: #ffffff;
        margin: 15px -10px -10px;

        .progress {
            background: #ffffff;
            height: 36px;
            border: 2px solid #ecf4d9;
            border-radius: 36px;
        }

        .free-delivery-status-text {
            top: 8px;
        }

        .progress-bar {
            background: #ecf4d9;
        }
    }

    &__delivery-text {
        background: #dbf1da;
        font-size: 13px;
        border-radius: 8px;
    }
}

.loadPrice {
  color: #ddd;
}
.cart {
  position: relative;
  display: flex;
  justify: content-end;
  z-index: 200;
  min-width: 111px;

  &:hover {
    .link {
      box-shadow: 0 -2px 12px #00000019;
      border-radius: 10px;
      background-color: #ffffff;

      &:after {
        width: 100%;
        height: 18px;
        background: #fff;
        position: absolute;
        bottom: -9px;
        left: 0;
        content: "";
        box-shadow: 5px 0 4px -5px #00000019;
      }
    }

    .cart-box {
      display: block;
    }
  }
}

.user.active {
  position: relative;
  display: flex;
  z-index: 200;

  .link {
    box-shadow: 0 -2px 12px #00000019;
    border-radius: 10px;
    background-color: #ffffff;

    &:after {
      width: 100%;
      height: 18px;
      background: #fff;
      position: absolute;
      z-index: 9;
      bottom: -9px;
      left: 0;
      content: "";
      box-shadow: 5px 0 4px -5px #00000019;
    }
  }
}

.site-header {
  position: fixed;
  top: 0;
  z-index: 310;
  left: 0;
  right: 0;
  background: #FFEEF6;
  box-shadow: 0 4px 4px -2px #00000014;
  transition: transform .5s;

  .headline-bar {
    color: #fff;
    padding: 0.5rem 1rem;
    text-align: center;
    font-size: 13px;
    align-items: center;
    display: flex;
    justify-content: center;


    @media (max-width: $breakPointForSmallHeader) {
      min-height: 48px;
    }

    p {
      margin: 0;
      font-size: 13px;
    }

    b {
      color: #fff;
    }

    a {
      color: #fff;
      text-decoration: underline;

      &:hover {
        color: #fff;
        text-decoration: none;
      }
    }
  }

  &__content {
      padding: 0 15px;
  }

  .site-minimal-header__support-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }

  .support-container__info {
    display: flex;
    flex-direction: column;
  }

  .support-container__link {
    color: #333333;
    text-decoration: underline;
    font-size: 12px;
  }

  .support-container__phone {
    color: #333333;
    font-size: 12px;
  }

  &.site-header--open {
    box-shadow: inset 0 -1px 3px 1px #00000014;
  }
  a {
    text-decoration: none;
  }

  &__container {
    display: grid;
    justify-items: center;
    grid-template-columns: 100%;
    align-items: center;
    max-width: 100%;
    margin: 0 auto;

    @media (min-width: 768px) {
      grid-template-columns: 180px auto max-content;
    }
  }
  &__corner {
    &:hover {
      &:after {
        content: "";
        width: 15px;
        height: 15px;
        position: absolute;
        bottom: 0;
        border-top: 0;
        background: #FFEEF6;
        z-index: 101;
      }

      &:after {
        border-left: 0;
        border-radius: 0 0 5px 0;
        left: -15px;
        box-shadow: inset -8px -6px 6px -5px #00000014;
        bottom: 1px;
      }
    }
  }
  &__center {
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    width: 100%;

    &__top {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
    }

    &__bottom {
      display: flex;
    }
  }
  &__right {
    display: flex;
    flex-direction: row;
    padding: 5px 0;
    gap: 10px;

    &--desktop {
      display: none;

      @media (min-width: 768px) {
        display: flex;
      }
    }

    &__link--active {
      box-shadow: 0 -2px 12px #00000019;
      border-radius: 10px;
      position: relative;

      &::after {
        position: absolute;
        bottom: -5px;
        left: -10px;
        width: 108%;
        height: 13px;
        background: #fff;
        content: "";
        z-index: 100;
      }
    }

    .link {
      gap: 10px;
      display: flex;
      flex-direction: row;
      padding: 9px 11px 7px;
      position: relative;
      color: #333333;
      z-index: 50;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      cursor: pointer;

      img {
        height: 20px;
        position: relative;
        z-index: 10;
      }

      span {
        position: relative;
        z-index: 10;
      }

      &__text {
        display: inline-block;
        padding: 0 0 0 10px;
        text-overflow: ellipsis;
        white-space: nowrap;

        &--hideable {
          display: none;

          @media (min-width: 992px) {
            display: inline-block;
          }
        }
      }

      &__count {
        border-radius: 50%;
        position: absolute;
        color: #fff;
        background: #e6007e;
        text-align: center;
        width: 20px;
        height: 20px;
        line-height: 20px;
        top: 0;
        left: 26px;
        font-size: 11px;
      }
    }
  }
  &__logo-container {
    width: 130px;
    height: auto;
    margin: 0;

    @media (min-width: $breakPointForSmallHeader) {
      max-width: 135px;
      height: 54px;
      margin: 0 20px 0 0;
      width: 100%;
    }
  }

  .site-minimal-header__logo-container {
    @media (min-width: $breakPointForSmallHeader) {
      margin-left: 80px;
    }
  }

  &__pinned-category, &__static-link {
    display: none;

    @media (min-width: $breakPointForSmallHeader) {
      display: flex;
      align-items: center;
      padding: 0 10px;
      border: 1px solid transparent;
      border-radius: 4px;
      border-bottom: 0;
      font-size: 14px;
      position: relative;
      color: #333333;
      white-space: nowrap;
    }

    &:hover {
      color: #e6007e;
      text-decoration: none;
    }

    span {
      line-height: 40px;
    }

    &:nth-child(n + 7) {
      display: none;
    }

    @media (max-width: 1199.98px) {
      &:nth-child(n + 5) {
        display: none;
      }
    }

    @media (max-width: 991.98px) {
      &:nth-child(n + 4) {
        display: none;
      }
    }

    img {
      margin-right: 5px;
    }
  }
  &--mobile-navigation-open {
    .site-header {
      &__logo {
        display: none;
      }

      &__static-link {
        display: none;
      }

      &__pinned-category {
        display: none;
      }

      &__center__top {
        margin-top: 0;
      }

      &__right__link {
        display: none;
      }
    }
  }
}

.header-sticky {
  .site-header {
    transition: transform .5s;
    transform: translateY(-200px);
    position: fixed;

    &__placeholder {
      display: block;
      height: 100px;
      flex: none;
      @media (min-width: 992px) {
        height: 134px;
      }
    }

    &__center {
      justify-content: center;
      padding-left: 0;
      padding-top: 0;

      &__top {
        order: 2;
        margin-top: 0;
      }

      &__bottom {
        order: 1;
      }
    }

    .whisperer-wrapper {
      @media (min-width: 1000px) {
        width: 100%;
        margin-left: 10px;
      }
    }

    &__pinned-category {
      &:nth-child(n + 4) {
        display: none;
      }

      @media (max-width: 1199.98px) {
        &:nth-child(n + 3) {
          display: none;
        }
      }

      @media (max-width: 991.98px) {
        display: none;
      }
    }

    &__static-link {
      display: none;
    }

    @media (max-width: 992px) {
      &__logo {
        display: none;
      }

      &__right__link {
        display: none;
      }
    }
  }
}

.site-ico__label {
  white-space: nowrap;
  color: #333;
  max-width: 115px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.site-header__right__link__count {
  background: #e6007e;
  position: absolute;
  color: white;
  width: 17px;
  height: 17px;
  border-radius: 17px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -2px;
  left: 22px;
}

@media (max-width: $breakPointForSmallHeader) {
  .site-header__container {
    flex-direction: column;
    padding-top: 10px;
  }
}

@media (max-width: $breakPointForSmallHeader) {
  .site-menu-container {
    background: #fff;
    display: none;
    overflow-y: auto;
  }
}

.noscroll .pageWrap>div {
    overflow: hidden;
}

.xmasBanner {
  display: flex;
  background-color: #567746;
  padding: 7px 15px;
  justify-content: space-around;
  align-items: center;
  font-size: 14px;
  color: #fff;
}

.xmasBanner__guarantee {
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    font-size: 12px;
    text-decoration: underline;
    color: #fff;

    &:hover {
      text-decoration: none;
    }
  }
}

.xmasBanner__pilulka-express {
  display: none;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    gap: 10px;

    &-header {
      font-weight: bold;
    }
  }
}

.xmasBanner__pilulka-box {
  display: none;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    gap: 10px;

    &-header {
      font-weight: bold;
    }
  }
}

.lg-only {
  @media (min-width: 768px) and (max-width: 1100px) {
    display: none!important;
  }
}

.minimal-header .site-header__container {
  @media (max-width: 768px) {
    grid-template-columns: 180px auto;
    justify-content: space-between;
    justify-items: normal;
    padding: 0;
  }
}
</style>
